export enum UserPrivilege {
  FULL = 'FULL',
  READONLY = 'READONLY',
  NONE = 'NONE',
}
